import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-layout='panorama']";

        if ($(selector).length) {
            if (log) console.log("%cfunction_panorama.js initialized", "color: green;");
            gsap.registerPlugin(ScrollTrigger);

            var blh = getCssVarValue("--blh");
            var columnSpace = getCssVarValue("--space-column");
            var columnWidth = getCssVarValue("--width-column");
            var globalSpace = getCssVarValue("--space-global");
            var padding = blh * 1.5;
            var isMobile = window.innerWidth <= 600;
            var largeViewportHeight = isMobile ? $(".height-100lvh").eq(0)[0].clientHeight : window.innerHeight;
            var tweens = [];

            function getExpandedWidth(_$children) {
                var width = 0;
                blh = getCssVarValue("--blh");
                columnSpace = getCssVarValue("--space-column");
                columnWidth = getCssVarValue("--width-column");
                globalSpace = getCssVarValue("--space-global");

                _$children.each(function (_i, _el) {
                    var factor = parseInt($(this).data("expand-to"));
                    var aspectRatio = _el.clientWidth / _el.clientHeight;

                    // Slide Width
                    width += factor * columnWidth * aspectRatio;
                    width += (factor - 1) * columnSpace * aspectRatio;

                    // Slide Gap
                    if (_i > 0) width += globalSpace;
                });

                // Margin
                width += globalSpace * 2;

                return width;
            }

            function init() {
                columnSpace = getCssVarValue("--space-column");
                columnWidth = getCssVarValue("--width-column");
                globalSpace = getCssVarValue("--space-global");
                padding = getCssVarValue("--blh") * 1.5;
                isMobile = window.innerWidth <= 600;
                largeViewportHeight = isMobile ? $(".height-100lvh").eq(0)[0].clientHeight : window.innerHeight;

                tweens.forEach(function (_tween) {
                    _tween.kill();
                });

                tweens = [];

                $(selector).each(function () {
                    var $instance = $(this);
                    var $audio = $instance.find(".audio");
                    var $slides = $instance.find(".slides");
                    var $captions = $instance.find("figcaption, .headline-wrapper");
                    var $children = $slides.find("figure");
                    var $scrollPort = $instance.find(".scrollport");
                    var initialWidth = window.innerWidth;
                    // var initialHeight = $slides.height();
                    var initialHeight = columnWidth * 3 + columnSpace * 2;
                    var expandedWidth = getExpandedWidth($children);
                    // var expandedHeight = largeViewportHeight - padding * 2;
                    var expandedHeight = largeViewportHeight;
                    var scrollDistance = expandedWidth - window.innerWidth;
                    var once = false;
                    var isClosing = false;
                    var audioLoaded = false;

                    $instance.find(".background").css("width", expandedWidth);

                    if (!isMobile) {
                        tweens.push(
                            gsap.fromTo(
                                $slides[0],
                                {
                                    width: initialWidth,
                                    height: initialHeight,
                                },
                                {
                                    width: expandedWidth,
                                    height: expandedHeight,
                                    ease: "sine.inOut",
                                    duration: getCssVarValue("--duration-lg") / 1000,
                                    onReverseComplete: function () {
                                        $slides.addClass("clip");
                                    },
                                    onComplete: function () {
                                        $slides.removeClass("clip");
                                        if (!isClosing) $captions.addClass("on");
                                    },
                                    scrollTrigger: {
                                        scroller: window,
                                        trigger: $instance[0],
                                        start: "top center-=25%",
                                        endTrigger: "html",
                                        end: "bottom top",
                                        onToggle: function (_self) {
                                            if (_self.isActive) {
                                                loadAudio();
                                            } else {
                                                $captions.removeClass("on");
                                            }
                                        },
                                        // end: "top top",
                                        // scrub: 1,
                                        toggleActions: "play reverse play reverse",
                                    },
                                }
                            )
                        );
                    } else {
                        $slides.css({
                            width: initialWidth,
                            height: initialHeight,
                        });
                        $slides.addClass("transition-lg");
                        ScrollTrigger.create({
                            scroller: window,
                            trigger: $instance[0],
                            start: "top center-=25%",
                            endTrigger: "html",
                            end: "bottom top",
                            onToggle: function (_self) {
                                if (_self.isActive) {
                                    $slides
                                        .css({
                                            width: expandedWidth,
                                            height: expandedHeight,
                                        })
                                        .one("transitionend", function () {
                                            if (!isClosing) $captions.addClass("on");
                                        });
                                    loadAudio();
                                } else {
                                    isClosing = true;
                                    $captions.removeClass("on");
                                    $slides
                                        .css({
                                            width: initialWidth,
                                            height: initialHeight,
                                        })
                                        .one("transitionend", function () {
                                            $scrollPort[0].scrollLeft = 0;
                                            isClosing = false;
                                        });
                                }
                            },
                            toggleActions: "play reverse play reverse",
                        });
                    }

                    if (!isMobile) {
                        tweens.push(
                            gsap.fromTo(
                                $slides[0],
                                {
                                    x: 0,
                                },
                                {
                                    x: -scrollDistance,
                                    ease: "none",
                                    scrollTrigger: {
                                        scroller: window,
                                        trigger: $instance[0],
                                        start: "top top",
                                        end: "bottom bottom",
                                        scrub: 1,
                                    },
                                }
                            )
                        );
                    }

                    function loadAudio() {
                        if (audioLoaded || !$audio.length) return;

                        var $el = $audio.find("audio");
                        var data = {
                            src: $el.data("src") || $el.attr("src"),
                        };

                        $el.attr({
                            src: data.src,
                        }).removeAttr("data-src data-type");
                        $el[0].load();
                        $el.on("canplay", function () {
                            $el.attr("data-lazy", "loaded");
                            audioLoaded = true;
                        });
                    }
                });
            }

            init();
            $(window).on("resizeEnd", init);
        }
    });
})();
